import React from 'react';
import {EditorContent, EditorContext, useEditor} from "@tiptap/react";
import RichTextToolbar from "../../rich-text/rich-text-toolbar.jsx";
import StarterKit from "@tiptap/starter-kit";
import TextAlign from "@tiptap/extension-text-align";
import Typography from "@tiptap/extension-typography";

const EditorInput = ({ callEditor, setMode }) => {

    const editor = useEditor({
        immediatelyRender: false,
        editorProps: {
            attributes: {
                autocomplete: "off",
                autocorrect: "off",
                autocapitalize: "off",
            },
        },
        extensions: [
            StarterKit,
            TextAlign.configure({ types: ["heading", "paragraph"] }),
            Typography,
        ],
        onFocus: () => {
            setMode?.('editor');
        },

        onBlur: () => {
            setMode?.('viewer');
        },
    });

    const editorClassName = [
        "w-full rounded-md bg-white",
        "focus:outline-none",
        "[&_.ProseMirror]:outline-none",
        //tamanho
        "[&_.ProseMirror]:min-h-[104px]",
        "[&_.ProseMirror]:print:min-h-fit",
        "[&_.ProseMirror]:max-h-[246px]",
        "[&_.ProseMirror]:print:max-h-fit",
        "[&_.ProseMirror]:print:pb-3!",
        "[&_.ProseMirror]:overflow-auto",
        "[&_.ProseMirror]:py-4 [&_.ProseMirror]:px-6",
        //lista
        "[&_.ProseMirror_ul]:list-disc [&_.ProseMirror_ul]:pl-6 [&_.ProseMirror_ul]:my-2",
        "[&_.ProseMirror_ol]:list-decimal [&_.ProseMirror_ol]:pl-6 [&_.ProseMirror_ol]:my-2",
        "[&_.ProseMirror_li]:my-1",
        //scroll
        "[&_.ProseMirror::-webkit-scrollbar]:block",
        "[&_.ProseMirror::-webkit-scrollbar]:w-2",
        "[&_.ProseMirror::-webkit-scrollbar-track]:bg-transparent",
        "[&_.ProseMirror::-webkit-scrollbar-thumb]:rounded",
        "[&_.ProseMirror::-webkit-scrollbar-thumb]:bg-zinc-200",
        "[&_.ProseMirror]:[scrollbar-width:thin]",
        "[&_.ProseMirror]:[scrollbar-color:rgb(228_228_231)_transparent]",
        //text
        "[&_.ProseMirror]:leading-9",
        "[&_.ProseMirror]:text-zinc-700",
        "[&_.ProseMirror]:!text-[13px]",
        "[&_.ProseMirror_p]:!text-[13px]",
        //link
        "[&_.ProseMirror_a:hover]:cursor-pointer",
        "[&_.ProseMirror_a:hover]:text-blue-500",
    ].join(" ");

    if (!editor) return null;

    return (
        <>
            <article className={`${!callEditor ? "hidden" : ""} w-full pt-2! ${(editor?.isEmpty || !editor?.getText()?.trim()) ? 'print:hidden!' : ''}`}>
                <EditorContext.Provider value={{ editor }}>
                    <RichTextToolbar wrapperClass="!border !border-zinc-200 !rounded-t-md !rounded-b-none !bg-white !shadow-none print:hidden!"/>

                    <section className={'relative print:mt-2! print:break-between-avoid!'}>
                        <div className="rounded-b-md border-t-0 border print:border-none! text-blue-600 border-zinc-200 print:overflow-y-visible! print:break-inside-auto!">
                            <EditorContent editor={editor} className={editorClassName}/>
                        </div>
                    </section>
                </EditorContext.Provider>
            </article>
        </>
    )
};

export default EditorInput;